module.exports = __webpack_public_path__ + "static/media/settings_new.e535b0d3.svg";